module.exports = __webpack_public_path__ + "img/rope-sealant-joint-repair-2.ece3603b.jpg";